<template>
    <v-overlay class="text-center" :value="overlay" z-index="999999999" opacity="0.7">
        <loading-spinner v-if="overlayLoading"/>
        <div v-else>
            <v-icon size="100">mdi-wifi-alert</v-icon>
            <div>{{ $t('common.reconnect_message') }}</div>
            <v-btn color="primary" :disabled="disabledBtn" depressed class="black--text mt-2" @click="reload">
                {{ $t('common.try_again') }}
            </v-btn>
        </div>
    </v-overlay>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {LoadingSpinner},
    data() {
        return {
            disabledBtn: false,
        }
    },
    computed: {
        ...mapState(['overlay', 'overlayLoading']),
    },
    mounted() {
        const vm = this
        window.addEventListener('online', vm.updateOnlineStatus);
        window.addEventListener('offline', vm.updateOnlineStatus);
    },
    methods: {
        ...mapMutations(['showOverlay', 'hideOverlay']),
        updateOnlineStatus() {
            const vm = this
            if (navigator.onLine) {
                vm.disabledBtn = false
                vm.hideOverlay()
            } else {
                vm.disabledBtn = true
                vm.showOverlay()
            }
        },
        reload() {
            const vm = this
            vm.$router.go(0)
        }
    }
}
</script>